module.exports = __webpack_public_path__ + "static/img/TORONTO_OAK.20c4b19.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/materials/Frendel/TORONTO_OAK.jpg
// module id = FxBL
// module chunks = 0